// Saurer Alma Technocorder TC2
import React from "react";
import { Input, Row } from "reactstrap";
import _ from "lodash";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { ColPrompt, CommonRows, InputRangeRow, ProgramNameRow, RadioButtonRow, RadioLabelCol, RunTimeRow } from "./index";

export default function MachineSaurerTC2() {
   const { onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   return (
      <>
         <ProgramNameRow valueProp="program" titleProp="Program #" />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999}
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Speed Setting"}
            descriptionProp={"rpm"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={15000}
            propertyNameProp={"speed"}
            errorDialogueProp={"0-15,000 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Number of Ends (Cabled)"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={9}
            propertyNameProp={"numEnds"}
            errorDialogueProp={"0-9 only"}
            floatProp={false}
         />
         <Row className="mb-2">
            <ColPrompt title={"Supply Tube Color"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.supplyTubeColor || ""}
                  onChange={(e) => {
                     if (e.target.value) {
                        onChange("extendedPropertyJson.supplyTubeColor", e.target.value);
                        if (errorDivDefinitions?.["supplyTubeColor"]) {
                           onChangeErrorDivDefinitions("supplyTubeColor", false);
                        }
                     } else {
                        onChange("extendedPropertyJson.supplyTubeColor", "");
                        onChangeErrorDivDefinitions("supplyTubeColor", true);
                     }
                  }}
               />
               {errorDivDefinitions.supplyTubeColor && (
                  <ErrorDiv>Cannot be left empty</ErrorDiv>
               )}
            </ColValue>
         </Row>
         <InputRangeRow
            titleProp={"Tension Setting"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={9.0}
            propertyNameProp={"tensionSet"}
            errorDialogueProp={"0.0-9.0 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Balloon Guide Height"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={9}
            propertyNameProp={"balloonGuide"}
            errorDialogueProp={"1-9 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Wraps On Spindle"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={3.0}
            propertyNameProp={"spindleWraps"}
            errorDialogueProp={"0.00-3.00 only"}
            floatProp={true}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"Pot Lids"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"potLidsGroup"}
               valueProp={"true"}
               onChangeProp={"potLids"}
               displayProp={"Yes"}
               trueFalseProp
            />
            <RadioLabelCol
               groupNameProp={"potLidsGroup"}
               valueProp={"false"}
               onChangeProp={"potLids"}
               displayProp={"No"}
               trueFalseProp
            />
         </RadioButtonRow>
         <InputRangeRow
            titleProp={"Wraps On Capstan"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={6}
            propertyNameProp={"capstanWraps"}
            errorDialogueProp={"1-6 only"}
            floatProp={false}
         />
         <RadioButtonRow
            promptRowSizeProp={3}
            valueRowSizeProp={4}
            titleProp={"Tension Device"}
            descriptionProp=""
         >
            <RadioLabelCol
               groupNameProp={"tensionDeviceGroup"}
               valueProp={"Flyer"}
               onChangeProp={"tensionDevice"}
               displayProp={"Flyer"}
               stringProp
            />
            <RadioLabelCol
               groupNameProp={"tensionDeviceGroup"}
               valueProp={"Yarn Tensioner"}
               onChangeProp={"tensionDevice"}
               displayProp={"Yarn Tensioner"}
               stringProp
            />
         </RadioButtonRow>
         {machineSetup.extendedPropertyJson?.tensionDevice === "Yarn Tensioner" && (
            <Row className="mb-2">
               <ColPrompt title={"Bullet Size"} bold={true} description="Yarn Tensioner Only" />
               <ColValue size={4}>
                  <Input
                     type="text"
                     style={{ borderRadius: "10px", fontSize: "14px" }}
                     value={machineSetup.extendedPropertyJson.bullet || ""}
                     onChange={(e) => {
                        if (_.includes(["1", "2", "4", "6"], e.target.value)) {
                           onChange("extendedPropertyJson.bullet", e.target.value);
                           if (errorDivDefinitions?.["bullet"]) {
                              onChangeErrorDivDefinitions("bullet", false);
                           }
                        } else {
                           onChange("extendedPropertyJson.bullet", "");
                           onChangeErrorDivDefinitions("bullet", true);
                        }
                     }}
                  />
                  {errorDivDefinitions.bullet && <ErrorDiv>1,2,4,6 only</ErrorDiv>}
               </ColValue>
            </Row>
         )}
         <CommonRows />
      </>
   );
}
